import styled, { css } from 'styled-components';
import { mediaQuery } from 'styles/helper';

export const TabbedFeaturesSelectorContainer = styled.div`
  .tabbed-features-selector-grid {
    overflow: auto;

    ${mediaQuery(
      'sm',
      css`
        /* Hide scrollbar for Chrome, Safari and Opera */
        &::-webkit-scrollbar {
          display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
      `
    )}
  }
`;
